'use strict';
var React = require('react');

var UserMenuComponentTemplate = require('./user-menu')
var ExtraMenuComponent = require('./extra-menu');

class HeaderMenuComponentTemplate extends React.Component {

    renderName() {
        if (this.props.user && this.props.user.Guest === false) {
            if (this.props.user.DisplayName) {
                return (
                    <React.Fragment>
                        <div id="name-user-mobile">
                            <p>{this.props.user.DisplayName.substring(0, 15)}</p>
                        </div>
                        <i id="angle-down-username" className="fa fa-angle-down"></i>
                    </React.Fragment>
                )
            }
            return (
                <React.Fragment>
                    <div>
                        <p>{(this.props.user.UserName || '').substring(0, 15)}</p>
                        <i className="fa fa-angle-down"></i>
                    </div>
                </React.Fragment>
            )
        }
        return (<p><a href={this.getLoginUrl()}>Iniciar sesión/Crear cuenta</a></p>);
    }


    getLoginUrl() {
        let loc = (location.pathname + location.search).substr(1)
        return `/accounts/non-private/sign-in?returnUrl=${loc}`
    }

    handleMobileToggleClick(e) {
        $(".header.mod li.h-extramenus").slideToggle();
        $(".mobile_top_toggler > span .fa-angle-down").toggleClass("rotate");
        $(".mobile_top_toggler > span").toggleClass('_menu');

        if ($(".mobile_top_toggler > span").hasClass('_menu'))
        {
            var $overlay = $('<div class="menu-overlay"></div>').on('click', function () {
                    $('.mobile_top_toggler > span').trigger('click');
                });
            $('body').append( $overlay )
        }
        else 
        {
            $('.menu-overlay').remove();
        }
    }

    renderCart() {
        const self = this;
        const userDetail = self.props.user;
	    var usuarioConsulta = 'NO';
        //if (typeof this.props.user != 'undefined') {
        //if (typeof this.props.user != 'undefined' && this.props.user.Guest === false) {   
            if(usuarioConsulta == 'SI') return (
                <li className="h-cart1">
                    <a href="" >
                        <i className=""></i>
                        <span> 
                            <span className="mobile-only"></span>&nbsp; 
                            <span className="" id="latest-cart-count"></span>
                        </span>
                    </a>
                    <div className="h-dd-menu h-cart-menu hide-me" style={{ overflow: 'hidden', outline: 'none', cursor: 'grab' }} tabIndex="1">
                        <div className="h-cart-mid"> 
                            <ul></ul>
                        </div>
                        <div className="h-cart-bot">
                            <a href="/cart" className="btn-view-cart custom-btn-view-cart"></a>
                        </div>
                    </div>
                    <div className="h-dd-menu add-cart">
                        <div className="h-cart-top">
                        </div>
                        <div className="h-cart-mid">
                            <ul>
                                <li className="cart-item">
                                    <div className="item-img">
                                        <span className="helper"></span>
                                        <img alt="" src={null}></img>
                                    </div>
                                    <div className="item-info">
                                        <p></p>
                                        <div className="item-price">
                                          <span className="currency"></span>
                                          <span className="value"></span>
                                       </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="h-cart-bot">
                            <a href="/cart" className="btn-view-cart" id="custom-btn-view-cart"></a>
                        </div>
                    </div>                
                </li>);
            return (
                <li className="h-cart" id="h-cart-header">
                    <a href="/cart">
                        <img alt="" className="header-option-icon" src="/assets/images/bepensa/cart.svg"></img>
                        <span> 
                            <span className="mobile-only">Carrito</span> 
                            (<span className="cart-count" id="latest-cart-count">0</span>)
                        </span>
                    </a>
                    <div className="h-dd-menu h-cart-menu hide-me" id="preview-cart-modal" style={{ overflow: 'hidden', outline: 'none', cursor: 'grab' }} tabIndex="1">
                        <div className="h-cart-mid"> 
                            <ul></ul>
                        </div>
                        <div className="h-cart-bot">
                            <a href="/cart" className="btn-view-cart custom-btn-view-cart"> Ver carrito </a>
                        </div>
                    </div>
                    <div className="h-dd-menu add-cart">
                        <div className="h-cart-top">Artículo agregado a carrito!
                        </div>
                        <div className="h-cart-mid">
                            <ul>
                                <li className="cart-item">
                                    <div className="item-img">
                                        <span className="helper"></span>
                                        <img alt="" src={null}></img>
                                    </div>
                                    <div className="item-info">
                                        <p></p>
                                        <div className="item-price">
                                          <span className="currency"></span>
                                          <span className="value"></span>
                                       </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="h-cart-bot">
                            <a href="/cart" className="btn-view-cart" id="custom-btn-view-cart"> Ver carrito </a>
                        </div>
                    </div>                
                </li>
            )

        //}

  	    
    }

    renderTagOffers(){
        if (this.props.panels != null) {
            return this.props.panels.map(function (panel, index1) {
                if (panel.Type == 'ExternalLinkHeader' && panel.Details && panel.Details.length >= 1) {
                    return panel.Details.map(function (detail, index2) {
                        if(detail.Title == "Ofertas")
                        {
                            return (
                                <li key={index2} className="custom-li">
                                    <a href={detail.Url} className="header-option-container">
                                        <img alt="" className="header-option-icon" src="/assets/images/bepensa/offers-icon.svg"></img>
                                        {detail.Title}
                                    </a>
                                </li>)
                        }
                    })
                }
            });
        }
    }

    renderTagOrderAgil(){
        if (typeof this.props.user != 'undefined' && this.props.user.Guest === false) {
            const self = this;
            const userDetail = self.props.user; 
            var tipodeCliente = 'B2C';
            if(userDetail) {
                if(userDetail.CustomFields) {
                    if(userDetail.CustomFields.find(x => x.Name == "Tipo de Usuario")) {
                        tipodeCliente  = userDetail.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0];
                    }
                }
            }
            if(tipodeCliente == 'B2B'){
                if (this.props.panels != null) {
                    return this.props.panels.map(function (panel, index1) {
                        if (panel.Type == 'ExternalLinkHeader' && panel.Details && panel.Details.length >= 1) {
                            return panel.Details.map(function (detail, index2) {
                                if(detail.Title != "Ofertas")
                                {
                                    if(detail.Title == "Pedido Ágil"){
                                        detail.Title = "Pedido Ágil";
                                        detail.Url ="/pedido-agil";
    
                                        return (
                                            <li key={index2} className="custom-li" id="option-agil-header">
                                                <a href={detail.Url} className="header-option-container">
                                                    {/*<img className="header-option-icon" src="/assets/images/bepensa/order-agil.svg"/>*/}
                                                    {/*detail.Title*/}
                                                    Pedido ágil
                                                </a>
                                            </li>)
                                    }
                                    
                                }
                            })
                        }
                    });
                }
            }
        }
    }

    render() { 
        return (
            <div className="pull-right" id="custom-header-left">
                <ul className="header-menus" id="header-menus-general">
                    {<UserMenuComponentTemplate {...this.props}></UserMenuComponentTemplate>}
                    <li className="mobile_top_toggler">
                        <span id="container-name-us" onClick={(e) => this.handleMobileToggleClick(e)}>
                            <span>
                                {this.renderName()}
                            </span>
                        </span>
                    </li>
                    {this.renderTagOrderAgil()}
                    {this.renderTagOffers()}
                    {this.renderCart()}
                   {<ExtraMenuComponent {...this.props}></ExtraMenuComponent>}
                </ul> 
            </div>
        );
    }
}

module.exports = HeaderMenuComponentTemplate;